// import $ from 'jquery';

$ = window.jQuery;

window.baseDomain = window.location.hostname.substring(window.location.hostname.indexOf('.') + 1)

window.setCookie = function(name, value, expireDays, globalhost) {
	var exdate = new Date();
	exdate.setDate(exdate.getDate() + expireDays);
	var str = name + '=' + value + '; path=/; expires=' + exdate.toUTCString();
	if (globalhost) {
		str += '; domain=' + window.baseDomain;
	}
	document.cookie = str;
}

window.getCookie = function(name) {
	if (document.cookie.length > 0) {
		var pos = document.cookie.lastIndexOf(name + '=');
		if (pos != -1) {
			pos += name.length + 1;
			var pos2 = document.cookie.indexOf(';', pos);
			if (pos2 == -1) {
				pos2 = document.cookie.length;
			}
			var content = document.cookie.substring(pos, pos2);
			return unescape(content);
		}
	}
	return null;
}

function customizeExitPopup() {
	var obj = $('.exitpopup-modal-window');
	
	obj.css('width', 'auto'); // Remove !important
	obj.css('width', ''); // Remove width at all. Does not work without removing !important first.
}

$(document).ready(function () {
	const loadMoreBtn = $('#loadmore');
	
	customizeExitPopup();

	loadMoreBtn.on('click', () => {

		$.ajax({
			url: window.common.ajax_url,
			method: 'POST',
			data: {
				action: 'loadmore',
				query: window.common.posts,
				page: window.common.current_page,
				pages_need: window.common.pages_need,
				is_front_page: window.common.is_front_page
			},
			beforeSend: () => {
				loadMoreBtn.text(window.txtLoading);
				loadMoreBtn.prop('disabled', true);
			},
			success: (data) => {
				if (data) {
					const query = new URLSearchParams(window.location.search);
					query.set('page', +window.common.current_page + 1);
					window.history.pushState(null, '', window.location.origin + window.location.pathname + `?${query.toString()}`);

					$('.articles').find('article:last-child').after(data);

					window.common.current_page++;

					if (window.common.current_page == window.common.max_page) {
						loadMoreBtn.remove();
					} else {
						loadMoreBtn.text(window.txtShowMore);
						loadMoreBtn.prop('disabled', false);
					}
				} else {
					loadMoreBtn.remove();
				}
			},
			error: (error) => {
				console.error(error);
				console.error('Cant load articles');
			}
		})
	})

	$('#categories-popup-toggle').on('click', (e) => {
		e.stopPropagation();
		$('#categories-popup').toggleClass('d-none');
		$('#categories-popup-toggle').toggleClass('open');
	})

	$(document).on('click', (e) => {
		let popup = document.getElementById('categories-popup');
		if (!popup.contains(e.target)) {
			$('#categories-popup').addClass('d-none');
			$('#categories-popup-toggle').removeClass('open');
		}
	});

	$('.languages-btn').on('click', () => {
		$('.languages-selector').toggleClass('d-none');
		$('body').toggleClass('menu-open');
	})

	$('.languages-selector__close').on('click', () => {
		$('.languages-selector').addClass('d-none');
		$('body').removeClass('menu-open');
	})

	$('form#subscription input').on('change', () => {
		$('form#subscription input').removeClass('error');
	})

	$('form#subscription').on('submit', () => {
		const frm = $(this);
		const inpCompany = frm.find('input[name=company]');
		const inpCount = frm.find('input[name=count]');
		const inpEmail = frm.find('input[name=email]');
		
		let company = inpCompany.val();
		let count = inpCount.val();
		let email = inpEmail.val();

		if (email === '') {
			inpEmail.addClass('error');
			return false;
		}
		
		if (company == '') {
			company = inpCompany.attr('placeholder');
		}

		$.ajax({
			url: 'https://app.' + window.baseDomain + '/ctrl/emails/subscription/save',
			method: 'POST',
			data: {
				company: company,
				count: count,
				email: email,
				lang: window.common.lang
			},
			success: () => {
				$('form#subscription').addClass('d-none');
				$('.submit-success').removeClass('d-none');
				sendGaEvent('blog_newsletter_subscribed_banner');
			},
			error: () => {
				alert('something went wrong')
			}
		});
		
		return false;
	})

	$('.btn_top_search').on('click', () => {
		$('.search-form').toggleClass('open')
		$('.search-form input').focus();
	})

	$('.search-form').on('focusout', () => {
		$('.search-form').toggleClass('open')
	})

	$('.sandwitch-wrapper').on('click', function(event){
		event.preventDefault();
		const wrapper = $('.sandwitch-wrapper')
		const elem = $(this).find('.sandwitch')
		$(wrapper).toggleClass('open');
		$(elem).toggleClass('sandwitch--open');

		$('#navbar').toggleClass('collapse')
		$('body').toggleClass('menu-open');
	})

	const readProgress = $('.read-progress');

	if (readProgress.length) {
		const footerHeight = 1450;
		const readingProgress = document.querySelector('#reading-progress-fill');

		const calculateWidth = () => {
			let w = (document.body.scrollTop || document.documentElement.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight - footerHeight) * 100;
			readingProgress.style.setProperty('width', w + '%');
		}

		calculateWidth();

		document.addEventListener('scroll', () => {
			calculateWidth();
		})
	}

	if (window.scrollY >= 1) {
		$('#header').addClass('shorted');
		$('.subheader').css('z-index', -1)
	}

	$(window).on('scroll', () => {
		if (window.scrollY >= 1) {
			$('#header').addClass('shorted');
			$('.subheader').css('z-index', -1)
		} else {
			$('#header').removeClass('shorted');
			$('.subheader').css('z-index', 10)
		}
	})

	$('[data-event="accept"]').on('click', (e) => {
		e.preventDefault();
		$('body').trigger('cns_start');
	})

	$('[data-event="close"]').on('click', (e) => {
		e.preventDefault();
		$('body').trigger('cns_start');
	})

	$('[data-event="more"]').on('click', (e) => {
		e.preventDefault();
		$('.cookies-notice').remove();
		$('.cookies-notice__modal').toggleClass('show');
	})

	$('.cn_ch').on('change', function() {
		var inp = $(this);
		var id = inp.attr('id');
		var v = 'yes';
		if (!inp.prop('checked')) {
			v = 'no';
		}
		setCookie(id, v, 365);
	});

	window.sendGaEvent = function(eventName) {
		dataLayer.push({'event': 'ga_event', 'event_name': eventName });
	}

	$('body').on('cns_start', function() {
		$('.cookies-notice').remove();

		gtag('consent', 'update', {
			'analytics_storage': getCookie('cn_analytics') != 'no' ? 'granted' : 'denied',
			'ad_storage': getCookie('cn_social') != 'no' ? 'granted' : 'denied',
			'ad_user_data': getCookie('cn_social') != 'no' ? 'granted' : 'denied',
			'ad_personalization': getCookie('cn_social') != 'no' ? 'granted' : 'denied',
		});
		gtag('event', 'consent_updated');

		var eventData = {'event': 'ga_init'};

		if(typeof mgaexpid !== 'undefined') {
			eventData.exp = mgaexpid + '.' + mgaexpvar;
			eventData.dimension2 = 'Exp: ' + mgaexptxt + ' Val: ' + mgaexpvar;
		}
		dataLayer.push(eventData);

		$('body').removeClass('cns');
	});

	$('[data-ga-event]').click(function(e) {
		var event = $(this).attr('data-ga-event');
		sendGaEvent(event);
	})

	$(window).on('beforeunload', function(e) {
		if(!getCookie('_ga')) {
			$('body').trigger('cns_start');
		}
	});
})
